import React from 'react'
import { navigate } from '@reach/router'
import { makeStyles } from '@material-ui/styles'
import { Typography } from '@material-ui/core'
import qs from 'qs'
import { Page } from 'components'
import Results from './Results'
import SearchBar from './SearchBar'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
}))

const Contacts = props => {
  const { location } = props

  const classes = useStyles()

  const handleFilter = values => {
    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true }) || {}
    const newParams = {
      ...queryParams,
      ...values,
    }
    const newSearchString = qs.stringify(newParams)
    navigate(`/contacts?${newSearchString}`)
    
  }

  const handleSearch = value => {
    navigate(`/contacts/?search=${value}`)
  }

  return (
    <Page className={classes.root} title="Elever og lærere">
      <Typography component="h1" variant="h3" gutterBottom>
        Elever og lærere
      </Typography>
      <SearchBar onFilter={handleFilter} onSearch={handleSearch} />
      <Results className={classes.results} location={location} />
    </Page>
  )
}

export default Contacts
